import { connect } from 'react-redux';
import { chooseColorSelector } from '../../../../../../redux/product/product.selectors';
import { chooseColorDispatcher } from '../../../../../../redux/product/product.dispatchers';
import { ChooseColorComponent } from './choose-color';
export const ChooseColor = connect(chooseColorSelector, chooseColorDispatcher)(ChooseColorComponent);